<div *ngIf="isLoading" class="spinner-overlay">
    <div class="spinner">
        <mat-spinner></mat-spinner>
    </div>
</div>

<body>
    <div class="headerContratos">
        <div class="tituloPag">
            <h3 class="subtitulo" style="font-family: 'Times New Roman', Times, serif;">Detalhes Fluxo de Containers
            </h3>
        </div>
        <div class="align-right">
            <div class="icone-setting">
                <div class="icone-setting">
                    <button class="btn-frete icone-setting" mat-button (click)="solicitarFrete()"><i-feather
                            name="file-plus"></i-feather>Adicionar transportador</button>
                </div>
            </div>
        </div>
    </div>
    <ul class="ladoAlado">
        <table class="tabelas" id="excel-table">
            <thead>
                <tr>
                    <th>Percuso</th>
                    <th>Editar</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of items; let i = index">
                    <td>
                        <table class="custos">
                            <thead>
                                <th>Código</th>
                                <th>Origem</th>
                                <th>Destino</th>
                                <th>Distância</th>
                            </thead>
                            <tr *ngFor="let veiculo of item.veiculo;">
                                <td>Percurso {{ i }}</td>
                                <td>{{ formatarComoMoeda(veiculo.km0a50) }}</td>
                                <td>{{ formatarComoMoeda(veiculo.km51a100) }}</td>
                                <td>{{ formatarComoMoeda(veiculo.km101a200) }}</td>
                            </tr>
                        </table>
                    </td>          
                    <td>
                        <button [disabled]="!isCarrierEnabled && !isAdminEnabled" mat-icon-button color="primary"
                            aria-label="Editar" (click)="editPercurso(item, i)">
                            <span class="material-icons">edit</span>
                        </button>
                        <button [disabled]="usuarioLogado.role != '9' && usuarioLogado.role != '2'" mat-icon-button
                            color="warn" aria-label="Excluir" (click)="deleteItem(item.ID, urlConsulta, query)">
                            <span class="material-icons">delete</span>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
        <table class="tabelas" id="excel-table">
            <thead>
                <tr>
                    <th>Peso</th>
                    <th>Editar</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of items; let i = index">
                    <td>
                        <table class="custos">
                            <thead>
                                <th>Código</th>
                                <th>Descrição</th>
                                <th>TON</th>
                            </thead>
                            <tr *ngFor="let veiculo of item.veiculo;">
                                <td>Peso {{ i }}</td>
                                <td>{{ formatarComoMoeda(veiculo.km0a50) }}</td>
                                <td>{{ formatarComoMoeda(veiculo.km51a100) }}</td>
                            </tr>
                        </table>
                    </td>           
                    <td>
                        <button [disabled]="!isCarrierEnabled && !isAdminEnabled" mat-icon-button color="primary"
                            aria-label="Editar" (click)="editPeso(item, i)">
                            <span class="material-icons">edit</span>
                        </button>
                        <button [disabled]="usuarioLogado.role != '9' && usuarioLogado.role != '2'" mat-icon-button
                            color="warn" aria-label="Excluir" (click)="deleteItem(item.ID, urlConsulta, query)">
                            <span class="material-icons">delete</span>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </ul>
</body>

<clr-modal [(clrModalOpen)]="dialogOpenPercurso" [clrModalSize]="'md'" class="dialog-container">
    <h3 class="modal-title">PERCURSOS</h3>
    <div class="modal-body scroll-container">
        <form class="inputs">
            <table class="table3000">
                <tr *ngFor="let veiculo of item.veiculo; let i = index">                
                    <!-- <tr *ngFor="let veiculo of item.veiculo; let i = index"> -->
                    <td>
                        <label>Origem</label>
                        <input type="decimal" [name]="'km0a50' + i" [(ngModel)]="veiculo.km0a50">
                    </td>
                    <td>
                        <label>Destino</label>
                        <input type="decimal" [name]="'km51a100' + i" [(ngModel)]="veiculo.km51a100">
                    </td>
                    <td>
                        <label>Distância</label>
                        <input type="decimal" [name]="'km101a200' + i" [(ngModel)]="veiculo.km101a200">
                    </td>
                </tr>
            </table>
            <div class="modal-div">
                <button class="modal-button" type="button" (click)="salvar2(item)">Save</button>
                <button class="modal-button" type="button" (click)="cancel()">Cancel</button>
            </div>
        </form>
    </div>
</clr-modal>

<clr-modal [(clrModalOpen)]="dialogOpenPesos" [clrModalSize]="'md'" class="dialog-container">
    <h3 class="modal-title">PESOS</h3>
    <div class="modal-body scroll-container">
        <form class="inputs">
            <table class="table3000">
                <tr *ngFor="let veiculo of item.veiculo; let i = index">                
                    <!-- <tr *ngFor="let veiculo of item.veiculo; let i = index"> -->
                    <td>
                        <label>Descrição</label>
                        <input type="decimal" [name]="'km0a50' + i" [(ngModel)]="veiculo.km0a50">
                    </td>
                    <td>
                        <label>TON</label>
                        <input type="decimal" [name]="'km51a100' + i" [(ngModel)]="veiculo.km51a100">
                    </td>
                </tr>
            </table>
            <div class="modal-div">
                <button class="modal-button" type="button" (click)="salvar2(item)">Save</button>
                <button class="modal-button" type="button" (click)="cancel()">Cancel</button>
            </div>
        </form>
    </div>
</clr-modal>

<div *ngIf="isLoading" class="spinner-overlay">
    <div class="spinner">
        <mat-spinner></mat-spinner>
    </div>
</div>